app.service('sufficientOutletCategory', function(
	modal,
	lazyLoad,
	pageConfig
) {
	let $sufficientOutletProductList;
	let previewModal;
	let galleryModal;
	let $addToCartButton;

	function loadProductList(data) {
		return $.ajax({
			url: '/outlet-product-loader.ltr',
			data
		});
	}

	function loadSingleProductPreview(data) {
		return $.ajax({
			url: '/outlet-product-individual-offers-preview.ltr',
			data
		});
	}

	function handleGalleryModalOpen($modal, startIndex = 0) {
		const carousel = new PreviewGallery({
			selector: $modal.find('.sufficient-product-photo-preview'),
			startIndex,
			onChange: function() {
				$modal
					.find('.carousel-thumbnail')
					.eq(this.currentSlide)
					.addClass('active')
					.siblings()
					.removeClass('active');
			},
			onInit: function() {
				$modal
					.find('.carousel-thumbnail')
					.eq(startIndex)
					.addClass('active');

				$modal.find('.sufficient-product-photo-preview').swipe({
					swipe: (e, direction) => {
						if (direction === 'left') {
							this.next();
						}
						if (direction === 'right') {
							this.prev();
						}
					}
				});
			}
		});

		$modal.on('click', '.js-carousel-thumbnail', function() {
			$(this)
				.addClass('active')
				.siblings()
				.removeClass('active');

			const position = $(this).index();
			carousel.goTo(position);
		});
	}

	function showGalleryModal(content, startIndex) {
		const GALLERY_MODAL_SELECTOR = 'sufficient-product-gallery';

		galleryModal = modal.generate({
			id: GALLERY_MODAL_SELECTOR,
			cssClass: GALLERY_MODAL_SELECTOR,
			modifier: 'remodal-full-width',
			header: 'Galeria',
			content,
			callbackOpen: function() {
				const $modal = this.$modal;
				handleGalleryModalOpen($modal, startIndex);
			},
			callbackClose: e => {
				if (e.target.id === GALLERY_MODAL_SELECTOR) {
					previewModal.open();
				}
			}
		});
	}

	function handlePreviewCarouselThumbnailClick($modal, $thumbnail) {
		const content = $modal.find('.sufficient-product-gallery-modal').html();
		const startIndex = $thumbnail.index();

		showGalleryModal(content, startIndex);
	}

	function handleAcceptanceCheckboxClick() {
		const checked = $(this).prop('checked');
		const $acceptanceBox = $(this).closest('.acceptance-box');

		if (checked) {
			$addToCartButton.removeClass('is-disabled');

			$acceptanceBox.removeClass('show-error');
		} else {
			$addToCartButton.addClass('is-disabled');
			$acceptanceBox.addClass('show-error');
		}
	}

	function handleAddToCartClick() {
		if ($addToCartButton.hasClass('is-disabled')) {
			$(this)
				.closest('.sufficient-product-control')
				.find('.acceptance-box')
				.addClass('show-error');
			return false;
		}
	}

	function handlePreviewModalOpen() {
		const $productDescription = this.$modal.find(
			'.sufficient-product-description'
		);
		$addToCartButton = this.$modal.find('.add-to-cart');

		this.$modal
			.on('click', '.js-carousel-thumbnail', e =>
				handlePreviewCarouselThumbnailClick(this.$modal, $(e.currentTarget))
			)
			.on('click', '.js-read-more', e => {
				e.preventDefault();
				$productDescription.addClass('show-full-description');
			})
			.on('click', '.js-read-less', e => {
				e.preventDefault();
				$productDescription.removeClass('show-full-description');
			})
			.on('click', '.js-acceptance-box', handleAcceptanceCheckboxClick)
			.on('click', '.js-add-to-cart', handleAddToCartClick);

		setModalButtons(this.$modal);
	}

	function showPreviewModal(content) {
		previewModal = modal.generate({
			id: 'sufficient-product-preview',
			cssClass: 'sufficient-product-preview',
			modifier: 'remodal-full-width',
			header: 'Outlet',
			callbackOpen: handlePreviewModalOpen,
			content
		});
	}

	function showErrorModal(xhr) {
		const errorMessage =
			xhr.status === 400
				? xhr.responseText
				: `${xhr.status}: ${xhr.statusText}`;

		modal.alert(errorMessage);
	}

	function appendProducts(html) {
		$sufficientOutletProductList.html(html);
	}

	function showListLoadingErrorMessage() {
		modal.alert('Błąd pobierania listy produktów.');
	}

	function handleLoadMoreProductsClick() {
		const data = {
			productId: $(this).data('product-id'),
			outletCategoryId: $(this).data('outlet-category-id')
		};

		$sufficientOutletProductList.addClass('loading');

		loadProductList(data)
			.then(appendProducts)
			.fail(showListLoadingErrorMessage)
			.always(() => {
				$sufficientOutletProductList.removeClass('loading');
				lazyLoad.update();
				setProductInCartButton();
			});
	}

	function handleCheckProductClick() {
		const outletProductId = $(this)
			.closest('.outlet-category-item')
			.data('outlet-product-id');

		showIndividualOffer(outletProductId);
	}

	function showIndividualOffer(outletProductId) {
		loadSingleProductPreview({ outletProductId })
			.then(showPreviewModal)
			.fail(showErrorModal);
	}

	function setModalButtons($modal) {
		const $control = $modal.find('.sufficient-product-control');
		const huCode = '' + $control.data('hu-code');
		const huCodesInBasket = getHuCodesInBasket();

		if (huCodesInBasket.indexOf(huCode) > -1) {
			$control.addClass('is-active');
		}
	}

	function getHuCodesInBasket() {
		const { items } = pageConfig.getData('basket');
		return items.map(item => item.huCode);
	}

	function setProductInCartButton() {
		const huCodesInBasket = getHuCodesInBasket();
		const $checkProductButtons = $sufficientOutletProductList.find(
			'.check-product'
		);

		$checkProductButtons.each((i, button) => {
			const huCode = '' + $(button).data('hu-code');

			if (huCodesInBasket.indexOf(huCode) > -1) {
				$(button)
					.addClass('is-active')
					.text('W koszyku');
			} else {
				$(button)
					.removeClass('is-active')
					.text('Obejrzyj i kup');
			}
		});
	}

	function setEvents() {
		$('body')
			.on('click', '.js-load-more-outlet-products', handleLoadMoreProductsClick)
			.on('click', '.js-check-product', handleCheckProductClick);

		$(document).on('cartReady', setProductInCartButton);
	}

	function setElements() {
		$sufficientOutletProductList = $('.sufficient-outlet-list');
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init,
		showIndividualOffer
	};
});
